// kan-before-after.liquid
(window.KanInit = window.KanInit || []).push([
    'kan-before-after',
    function (root, KM) {
      /* Static mode has no scroll timeline to drive, so there is nothing to
         register — an update callback would burn a frame every scroll doing
         nothing. */
      if (root.classList.contains('kan-ba--static')) return null;

      var img = root.querySelector('[data-img]');
      var before = root.querySelector('[data-before]');
      var after = root.querySelector('[data-after]');
      var note = root.querySelector('[data-note]');
      var line = root.querySelector('[data-line]');
      if (!img) return null;

      return {
        update: function () {
          var p = KM.reduced() ? 1 : KM.pinProgress(root);

          var s = KM.lerp(2.1, 1.0, KM.easeIO(KM.seg(p, 0.68, 1)));
          var shift = ((s - 1) / 2) * 100; /* % needed to reach an edge */
          var x;
          if (p < 0.34) {
            x = shift * KM.lerp(1, 0.92, KM.seg(p, 0, 0.34));
          } else if (p < 0.68) {
            x = KM.lerp(shift * 0.92, -shift * 0.92, KM.easeIO(KM.seg(p, 0.34, 0.68)));
          } else {
            x = KM.lerp(-shift * 0.92, 0, KM.easeIO(KM.seg(p, 0.68, 1)));
          }

          img.style.transform = 'translateX(' + x + '%) scale(' + s + ')';

          if (before) {
            var ob = 1 - KM.seg(p, 0.3, 0.46);
            before.style.opacity = String(ob);
            before.style.transform =
              'translateY(' + (1 - ob) * -30 + 'px) scale(' + KM.lerp(0.9, 1, ob) + ')';
          }

          if (after) {
            var oa = KM.seg(p, 0.5, 0.66) * (1 - KM.seg(p, 0.8, 0.94));
            after.style.opacity = String(oa);
            after.style.transform =
              'translateY(' + (1 - oa) * 30 + 'px) scale(' + KM.lerp(0.9, 1, oa) + ')';
          }

          if (line) line.style.opacity = String(KM.seg(p, 0.74, 0.9) * 0.55);

          if (note) {
            var on = KM.seg(p, 0.82, 0.96);
            note.style.opacity = String(on);
            note.style.transform = 'translateY(' + (1 - on) * 30 + 'px)';
          }
        }
      };
    }
  ]);

// kan-chrome.liquid
(window.KanInit = window.KanInit || []).push([
    'kan-chrome',
    function (root, KM) {
      var bar = root.querySelector('[data-bar]');
      var pre = root.querySelector('[data-pre]');
      var timers = [];

      if (pre) {
        /* Once per session. sessionStorage can throw in a locked-down browser,
           so a failure must still dismiss the overlay rather than trap the
           visitor behind it. */
        var seen = false;
        try {
          seen = sessionStorage.getItem('kan:pre') === '1';
        } catch (e) {
          seen = false;
        }

        var dismiss = function () {
          pre.classList.add('is-done');
          try {
            sessionStorage.setItem('kan:pre', '1');
          } catch (e) {
            /* ignore */
          }
        };

        if (seen || KM.reduced()) {
          pre.classList.add('is-done');
        } else {
          if (document.readyState === 'complete') {
            timers.push(setTimeout(dismiss, 400));
          } else {
            window.addEventListener('load', function () {
              timers.push(setTimeout(dismiss, 400));
            });
          }
          /* Safety net: never hold the page behind the overlay. */
          timers.push(setTimeout(dismiss, 1800));
        }
      }

      if (!bar) {
        return { destroy: function () { timers.forEach(clearTimeout); } };
      }

      return {
        update: function () {
          bar.style.transform =
            'scaleX(' + KM.clamp(KM.scrollY() / KM.scrollMax()) + ')';
        },
        destroy: function () {
          timers.forEach(clearTimeout);
        }
      };
    }
  ]);

// kan-cta.liquid
(window.KanInit = window.KanInit || []).push([
    'kan-cta',
    function (root, KM) {
      var orb = root.querySelector('[data-orb]');
      var inner = root.querySelector('[data-inner]');
      if (!orb) return null;

      return {
        update: function () {
          var p = KM.reduced() ? 1 : KM.pinProgress(root);
          var e = KM.easeIO(Math.min(1, p / 0.62)); /* first 62% grows */

          var start = 76;
          var finish = Math.min(660, window.innerWidth * 0.92, window.innerHeight * 0.86);
          var size = KM.lerp(start, finish, e);

          orb.style.width = size + 'px';
          orb.style.height = size + 'px';
          orb.style.borderRadius = Math.max(34, (size / 2) * (1 - e) + 34 * e) + 'px';
          orb.style.transform = 'translateY(' + (1 - e) * 28 + 'vh)';

          if (inner) {
            var ip = KM.clamp((e - 0.68) / 0.32);
            inner.style.opacity = String(ip);
            inner.style.transform =
              'translateY(' + (1 - ip) * 26 + 'px) scale(' + KM.lerp(0.94, 1, ip) + ')';
            /* Keep the collapsed orb's contents out of the tab order and away
               from screen readers until it has actually opened. */
            inner.inert = ip < 0.4;
            inner.setAttribute('aria-hidden', ip < 0.4 ? 'true' : 'false');
            inner.style.pointerEvents = ip < 0.4 ? 'none' : '';
          }
        }
      };
    }
  ]);

// kan-hero.liquid
(window.KanInit = window.KanInit || []).push([
    'kan-hero',
    function (root, KM) {
      var bottle = root.querySelector('[data-bottle]');
      var canvas = root.querySelector('[data-dust]');
      var parallax = root.getAttribute('data-parallax') !== 'false';
      var raf = 0;

      /* ---- drifting dust motes ------------------------------------------
         Rebuilt on layout rather than on every frame: the mote count is
         derived from width, so it only changes when the canvas resizes. */
      var ctx = null;
      var motes = [];
      var w = 0;
      var h = 0;

      function buildMotes() {
        if (!canvas || !ctx) return;
        var dpr = Math.min(window.devicePixelRatio || 1, 2);
        w = canvas.clientWidth;
        h = canvas.clientHeight;
        if (!w || !h) return;
        canvas.width = w * dpr;
        canvas.height = h * dpr;
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

        var n = Math.round(Math.min(90, w / 14));
        motes = [];
        for (var i = 0; i < n; i++) {
          motes.push({
            x: Math.random() * w,
            y: Math.random() * h,
            r: Math.random() * 1.5 + 0.3,
            vx: (Math.random() - 0.5) * 0.16,
            vy: (Math.random() - 0.5) * 0.12 - 0.05,
            a: Math.random() * 0.4 + 0.08
          });
        }
      }

      /* The dust drifts on its own clock, independent of scroll, so it runs on
         its own rAF loop — but only while the hero is on screen and motion is
         allowed. A hero scrolled past should not keep burning frames. */
      var visible = true;
      var observer = null;

      function drawDust() {
        raf = 0;
        if (!ctx || KM.reduced() || !visible) return;
        ctx.clearRect(0, 0, w, h);
        for (var i = 0; i < motes.length; i++) {
          var m = motes[i];
          m.x += m.vx;
          m.y += m.vy;
          if (m.x < -6) m.x = w + 6;
          if (m.x > w + 6) m.x = -6;
          if (m.y < -6) m.y = h + 6;
          if (m.y > h + 6) m.y = -6;
          ctx.beginPath();
          ctx.arc(m.x, m.y, m.r, 0, Math.PI * 2);
          ctx.fillStyle = 'rgba(210,220,230,' + m.a + ')';
          ctx.fill();
        }
        raf = requestAnimationFrame(drawDust);
      }

      if (canvas && canvas.getContext) {
        ctx = canvas.getContext('2d');
        if ('IntersectionObserver' in window) {
          observer = new IntersectionObserver(function (entries) {
            visible = entries[0].isIntersecting;
            if (visible && !raf && !KM.reduced()) raf = requestAnimationFrame(drawDust);
          });
          observer.observe(root);
        }
      }

      /* ---- hero slider ---------------------------------------------------
         Crossfade, not translate: the slides are stacked, so changing slide
         cannot shift layout or fight the scroll parallax applied to the whole
         stack. Auto-advance pauses on hover/focus and never runs under
         reduced-motion. */
      var slides = KM.toArray(root.querySelectorAll('[data-slide]'));
      var dots = KM.toArray(root.querySelectorAll('[data-dot]'));
      var slideTimer = 0;
      var current = 0;

      function show(i) {
        current = (i + slides.length) % slides.length;
        slides.forEach(function (s2) {
          s2.classList.toggle('is-active', s2.getAttribute('data-slide') === String(current));
        });
        dots.forEach(function (d) {
          var on = d.getAttribute('data-dot') === String(current);
          d.classList.toggle('is-active', on);
          d.setAttribute('aria-selected', on ? 'true' : 'false');
        });
      }

      function advance() { show(current + 1); }

      function startSlides() {
        if (slideTimer || slides.length < 2 || KM.reduced()) return;
        slideTimer = setInterval(advance, 4200);
      }

      function stopSlides() {
        if (!slideTimer) return;
        clearInterval(slideTimer);
        slideTimer = 0;
      }

      function onDot(e) { stopSlides(); show(e.currentTarget.getAttribute('data-dot')); }

      dots.forEach(function (d) { d.addEventListener('click', onDot); });

      var sliderEl = root.querySelector('[data-slider]');
      if (sliderEl) {
        sliderEl.addEventListener('mouseenter', stopSlides);
        sliderEl.addEventListener('mouseleave', startSlides);
        sliderEl.addEventListener('focusin', stopSlides);
      }
      startSlides();

      return {
        layout: function () {
          buildMotes();
          if (!raf && visible && !KM.reduced()) raf = requestAnimationFrame(drawDust);
        },

        update: function () {
          if (!bottle || !parallax) return;
          if (KM.reduced()) {
            bottle.style.transform = '';
            bottle.style.opacity = '';
            return;
          }
          var p = KM.clamp(-root.getBoundingClientRect().top / Math.max(root.offsetHeight, 1));
          bottle.style.transform =
            'translateY(' + -p * 120 + 'px) scale(' + (1 - p * 0.18) + ')';
          bottle.style.opacity = String(1 - KM.clamp(p / 0.85));
        },

        destroy: function () {
          stopSlides();
          dots.forEach(function (d) { d.removeEventListener('click', onDot); });
          if (raf) cancelAnimationFrame(raf);
          raf = 0;
          if (observer) observer.disconnect();
        }
      };
    }
  ]);

// kan-intro.liquid
(window.KanInit = window.KanInit || []).push([
    'kan-intro',
    function (root, KM) {
      var host = root.querySelector('[data-words]');
      if (!host) return null;

      /* Wrap every whitespace-separated run in <w>. Walking text nodes (rather
         than rewriting innerHTML) keeps <em>/<strong> from the richtext intact
         and avoids re-wrapping if this runs twice. */
      var words = (function () {
        if (host.querySelector('w')) return KM.toArray(host.querySelectorAll('w'));

        var walker = document.createTreeWalker(host, NodeFilter.SHOW_TEXT, null);
        var nodes = [];
        while (walker.nextNode()) nodes.push(walker.currentNode);

        nodes.forEach(function (node) {
          var parts = node.nodeValue.split(/(\s+)/);
          var frag = document.createDocumentFragment();
          parts.forEach(function (part) {
            if (!part) return;
            if (!part.trim()) {
              frag.appendChild(document.createTextNode(part));
              return;
            }
            var w = document.createElement('w');
            w.textContent = part;
            frag.appendChild(w);
          });
          node.parentNode.replaceChild(frag, node);
        });

        return KM.toArray(host.querySelectorAll('w'));
      })();

      if (!words.length) return null;

      return {
        update: function () {
          var p = KM.reduced() ? 1 : KM.scrubProgress(host, 0.88, 0.34);
          var n = words.length;
          for (var i = 0; i < n; i++) {
            var t = KM.clamp((p * (n + 5) - i) / 3.2);
            words[i].style.opacity = String(KM.lerp(0.08, 1, t));
            words[i].style.transform = 'translateY(' + (1 - t) * 9 + 'px)';
          }
        }
      };
    }
  ]);

// kan-steps.liquid
(window.KanInit = window.KanInit || []).push([
    'kan-steps',
    function (root, KM) {
      var grid = root.querySelector('[data-grid]');
      var fill = root.querySelector('[data-fill]');
      var steps = KM.toArray(root.querySelectorAll('.kan-step'));
      if (!grid || !steps.length) return null;

      return {
        update: function () {
          var p = KM.reduced() ? 1 : KM.scrubProgress(grid, 0.92, 0.48);
          if (fill) fill.style.transform = 'scaleX(' + p + ')';
          for (var i = 0; i < steps.length; i++) {
            steps[i].classList.toggle(
              'is-on',
              KM.reduced() || p >= (i + 0.45) / steps.length
            );
          }
        }
      };
    }
  ]);

// kan-sticky-atc.liquid
(window.KanInit = window.KanInit || []).push([
    'kan-sticky-atc',
    function (root, KM) {
      var showAfter = parseFloat(root.getAttribute('data-show-after'));
      if (isNaN(showAfter)) showAfter = 1;

      /* Hide the bar while the closing CTA is on screen — two buy buttons
         competing for the same tap reads as a bug, not as urgency. */
      var closing;

      return {
        update: function () {
          var past = KM.scrollY() > window.innerHeight * showAfter;

          closing = document.querySelector('[data-kan-section="kan-cta"]');
          var overClosing = false;
          if (closing) {
            var rect = closing.getBoundingClientRect();
            overClosing = rect.top < window.innerHeight * 0.5 && rect.bottom > 0;
          }

          root.classList.toggle('is-on', past && !overClosing);
          root.inert = !past || overClosing;
        }
      };
    }
  ]);

// kan-tech.liquid
(window.KanInit = window.KanInit || []).push([
    'kan-tech',
    function (root, KM) {
      var showcase = root.querySelector('[data-showcase]');
      if (!showcase) return null;

      return {
        update: function () {
          var e = KM.reduced() ? 1 : KM.easeIO(KM.scrubProgress(showcase, 0.96, 0.55));
          showcase.style.opacity = String(KM.clamp(e / 0.45));
          showcase.style.transform = 'scale(' + KM.lerp(0.9, 1, e) + ')';
          showcase.style.borderRadius = KM.lerp(64, 4, e) + 'px';
        }
      };
    }
  ]);
